import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { sendRequestItemToMNO } from '@api/assetsRent';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSendRequestItemToMNO = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutate: sendRequestToMNO } = useMutation({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: (comment: string) => id && sendRequestItemToMNO({ requestId: id, comment }),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
		enabled: [id],
	});

	return {
		sendRequestToMNO: sendRequestToMNO as unknown as (comment: string) => void,
	};
};
